import DateTimePickerComponent from 'components/common/DateTimePickerComponent';
import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const DeadlineTaskEditModal = ({ show, close, taskData, setTaskData }) => {
  const [tempData, setTempData] = useState('');

  useEffect(() => {
    if (show) {
      setTempData(taskData.deadline);
    }
  }, [show]);

  const handleSave = () => {
    setTaskData({ ...taskData, deadline: tempData });
    close();
  };

  return (
    <Modal show={show} onHide={close} centered>
      <Modal.Header closeButton>
        <Modal.Title>Editar Prazo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DateTimePickerComponent
          value={tempData}
          onChange={setTempData}
          placeholderText="Select Date"
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="falcon-default" onClick={() => close()}>
          Cancelar
        </Button>
        <Button onClick={() => handleSave()}>Salvar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeadlineTaskEditModal;
